export default __webpack_public_path__ + "static/logo-sctec-dark-8f20b14afe7e4c473d143aeff8289dbe.png";